import type { HTMLAttributes, PropsWithChildren } from "react";

import { css } from "@compiled/react";

import { Adg4TabFC } from "./tab-helper";
import { useAdg4TabsContext } from "./tabs";

export type Adg4TabPanelProps = PropsWithChildren<{
    forceRender?: boolean;
    panelIndex?: number;
}> &
    HTMLAttributes<HTMLDivElement>;

const hidePanelStyle = css({
    display: "none"
});

const Adg4TabPanel: Adg4TabFC<Adg4TabPanelProps> = ({
    forceRender,
    children,
    panelIndex,
    id,
    ...props
}: Adg4TabPanelProps) => {
    const { isCurrentTab } = useAdg4TabsContext();

    const isTabSelected = isCurrentTab(panelIndex);
    const activeClass = isTabSelected ? "active-panel" : "";

    return (
        <div
            {...props}
            css={[!isTabSelected && !forceRender && hidePanelStyle]}
            id={`panel${id}`}
            aria-labelledby={`tab${id}`}
            aria-hidden={!isTabSelected}
            role="tabpanel"
            className={["tab-panel", activeClass].join(" ")}
        >
            {forceRender || isTabSelected ? children : null}
        </div>
    );
};
Adg4TabPanel.tabsRole = "Adg4TabPanel";

export { Adg4TabPanel };
